import type { TicketDetail } from '@easyhelp/shared';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { Ref } from 'react';
import { StateChip, formatDateTime } from '../../components/ticket';

interface TicketHeaderProps {
  ticket: TicketDetail;
  /** Il titolo, che riceve il focus quando si apre un ticket. */
  titleRef?: Ref<HTMLHeadingElement>;
}

/**
 * Testata del dettaglio: codice (con il prefisso del prodotto, DEC-003), stato, titolo e apertura. Sta
 * sul fondo del pannello, senza card; il ritorno alla coda e il «?» sono nella barra fissa del
 * `TicketDetailDrawer`. Il titolo riceve il focus quando si apre un ticket.
 */
export function TicketHeader({ ticket, titleRef }: TicketHeaderProps) {
  return (
    <Box>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <Typography
          variant="body2"
          component="span"
          sx={{ fontFamily: (theme) => theme.typography.fontFamilyMonospace, fontWeight: 500 }}
        >
          {ticket.code}
        </Typography>
        <StateChip state={ticket.state} />
      </Stack>
      {/* Titolo, email e committente vanno a capo anche senza spazi: niente si taglia senza dirlo (#119). */}
      <Typography
        ref={titleRef}
        tabIndex={-1}
        variant="h5"
        component="h2"
        sx={{ outline: 'none', overflowWrap: 'anywhere' }}
      >
        {ticket.title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, overflowWrap: 'anywhere' }}>
        Aperto il {formatDateTime(ticket.receivedAt)} da {ticket.reporter.email} ·{' '}
        {ticket.committente ?? 'committente non identificato'}
      </Typography>
    </Box>
  );
}
